import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import Grid from "@mui/material/Grid";
//
import CustomTabs from "./CustomTabs";

const TopPanel = () => {
  const [value, setValue] = React.useState(0);

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs={12} sm={12} md={12}>
        <CustomTabs />
      </Grid>
    </Grid>
  );
};

export default TopPanel;
